import { useLoggedInWithOrgContextState } from "../auth/useLoggedInWithOrgContextState";

export const useSub = () => {
  const authState = useLoggedInWithOrgContextState();

  if (!authState) {
    throw Error("Auth state with org context not available");
  }

  return {
    hasContractAccess: authState.selectedOrg.subscription.hasContractAccess,
    hasBuyerAccess: authState.selectedOrg.subscription.hasBuyerAccess,
    hasSignatureAccess: authState.selectedOrg.subscription.hasSignatureAccess,
    hasBankIdAccess: authState.selectedOrg.subscription.hasBankIdAccess,
    canCreateEvents: authState.selectedOrg.canCreateEvent,
    canCreateContracts: authState.selectedOrg.canCreateContract,
    hasProductAccess: authState.selectedOrg.hasProductAccess,
    hasProjectAccess: authState.selectedOrg.hasProjectAccess,
    hasAiAccess: authState.selectedOrg.hasAiAccess,
    hasFencyContractSearchAccess: authState.selectedOrg.subscription.hasFencyContractSearchAccess,
    fencySyncEnabled: authState.selectedOrg.subscription.fencySyncEnabled,
    hasDocumentTemplateAccess: authState.selectedOrg.hasDocumentTemplateAccess,
    hasIFRSAccess: authState.selectedOrg.hasIFRSAccess,
    hasOrganizationAssessmentAccess: authState.selectedOrg.subscription.hasOrganizationAssessmentAccess,
    hasNegotiationAcces: authState.selectedOrg.subscription.hasNegotiationAccess,
    hasSourcingEventV2Access: authState.selectedOrg.subscription.hasSourcingEventV2Access,
  };
};

export type SubAccess = ReturnType<typeof useSub>;
